<template>

    <div>
        <el-form :inline="true" :model="query" class="query-form">
             <el-form-item class="query-form-item"  size="mini">时间：
                <span class="demonstration"></span>
                <el-date-picker
                    v-model="query.start_time"
                    type="date"
                    placeholder="开始时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
                -
                <el-date-picker
                    v-model="query.end_time"
                    type="date"
                    placeholder="结束时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd 23:59:59">
                </el-date-picker>
            </el-form-item> 

             <el-form-item>
                <el-button-group style="margin-top: -10%">
                    <el-button type="primary"  icon="el-icon-search" @click.native="onSubmit()" size="mini" >查询</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>
        <div id="line" style="width: 1000px;height:400px"></div>
    </div>

</template>

<script>
import { advertStatus, changeTime } from "../../api/posting/posting";
// import echarts from 'echarts';
var echarts = require('echarts')
export default {
    data() {
        return {
            loading: true,
            query: {
                find_id: '',
                start_time: '',
                end_time: '',
            },
            browserData: [],
            clickData: [],
            time: []
        };
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        timeFormdate(date) {
            if (!date || typeof(date) === 'string') {
                this.error("参数错误")
            }
            var y = date.getFullYear();
            var m = date.getMonth() +1;
            var d = date.getDate();
            return y + '-' + m + '-' + d;
        },
        timestampToTime(timestamp) {
            var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
            var D = date.getDate() + ' ';
            var h = date.getHours() + ':';
            var m = date.getMinutes() + ':';
            var s = date.getSeconds();
            return Y+M+D+h+m+s;
        },
        onSubmit() {
            if (this.query.start_time == '') {
                var date = new Date();
                date.setDate(1);
                this.query.start_time = this.timeFormdate(date) + ' 00:00:00';
            }
            if (this.query.end_time == '') {
                var time = new Date().getTime();
                this.query.end_time = this.timestampToTime(time)
            }
            var that = this
            this.loading = false;
            var searchData = {'start_time':this.query.start_time,'end_time':this.query.end_time,'find_id':this.query.find_id}
            advertStatus(searchData).then(response => {
                this.browserData = response.data.browserData
                this.clickData = response.data.clickData
                this.loading = false;
                that.setCharts()
            }).catch(() => {
                this.loading = false;
            });
            changeTime(searchData).then(response => {
                this.time = response.data
                this.loading = false;
                that.setCharts()
            }).catch(() => {
                this.loading = false;
            });

        },
        setCharts(){
            var myChart = echarts.init(document.getElementById('line'));
            // 指定图表的配置项和数据
            var option = {
                tooltip: {},
                legend: {
                    data:['浏览','点击']
                },
                xAxis: {
                    type: 'category',
                    data: this.time
                },
                yAxis: {},
                series: [
                    {
                    name: '浏览',
                    type: 'line',
                    data: this.browserData,
                    itemStyle : {
                        normal : {
                        color:'#00a3ff',
                        lineStyle:{
                            color:'#00a3ff'
                        }
                        }
                    },
                    },
                    {
                    name: '点击',
                    type: 'line',
                    data: this.clickData,
                    itemStyle : {
                        normal : {
                        color:'#ff7200',
                        lineStyle:{
                            color:'#ff7200'
                        }
                        }
                    },
                    },
                ]
            };

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
            setTimeout(function (){
                window.onresize = function () {
                myChart.resize();
                }
            },200)
        },
    },
    mounted() {
        this.$nextTick(()=>{
            this.setCharts()
        })
    },
    watch: {
        time(value){
            console.log(this.time)
            console.log(value)
        },
        clickData(value){
            console.log(value)
        },
        browserData(value){
            console.log(value)
        }
    },
    created() {
        this.query.find_id = this.$route.params.find_id ?  this.$route.params.find_id : 0 ;
        this.onSubmit();
    },
    watch: {
        // APIDATA(value){
        // this.$nextTick(()=>{
        //     let line = this.$refs.line
        //     this.setCharts1()
        //     for(let i in line){
        //         line[i].style.width = value.typical_education[i].data_value + '%'
        //     }
        // })
        // }
    }
};
</script>
<style type="text/scss" lang="scss">
</style>
<style>
 .el-form-item__label{
     margin-top: 5px;
 }
</style>
